// src/supabaseClient.js
import { createClient } from '@supabase/supabase-js'

// Access credentials from environment variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

// Debugging: Log the variables (remove these lines in production)
console.log('Supabase URL:', supabaseUrl)
console.log('Supabase Anon Key:', supabaseAnonKey ? 'Exists' : 'Not Found')

// Initialize Supabase client
const supabase = createClient(supabaseUrl, supabaseAnonKey)

export default supabase
